<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><a id="pagevi" title="vi">“[I do not] despair of the future. The truth is this: the march of Providence is so slow, and our desire so impatient, the work of progress so immense, and our means of aiding it so feeble, the life of humanity is so long, that of the individual so brief, that we often see only the ebb of the advancing wave and are thus discouraged. It is history that teaches us to hope.”</a></p><a id="pagevi" title="vi">
<p class="fm1">— Robert E. Lee to Charles Marshall, September 1870</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Front01.vue?83c8254e